<template>
  <main class="d-flex flex-md-row flex-xxs-column ">
    <div class="col-md-4 col-xxs-12 pt-lg-5 pt-xxs-3">
      <img class="d-flex fluid w-100 pt-lg-5 pt-md-0 mt-lg-5 mt-xxs-0" :alt="collection.name" :src="fileUrl(collection.banner+'?w=400')">
    </div>
    <div class="col-md-8 col-xxs-12">
      <!-- <ul class="d-flex p-0 m-0 flex-column col-md-8 col-xxs-12">
        <li v-for="product in collectionProducts" :key="product.id" class="d-flex mb-3">
          <a class="text-decoration-none d-flex justify-content-between align-items-start bg-black text-light w-100"
            :href="product.targetUrl"
          >
            <div class="d-flex flex-row align-items-streatch">
              <div>
                <img :src="fileUrl(product.imageUrl+'?h=80')" height="80">
              </div>
              <div class="d-flex flex-column justify-content-between py-2 px-3">
                <h6>{{ product.title }}</h6>
                <small class="text-warning-light">{{ product.publisher }}</small>
              </div>
            </div>
            <div class="d-flex align-items-end p-2">
              <b-badge variant="light">{{product.genre}}</b-badge>
            </div>
          </a>
        </li>
      </ul>-->
      <article class="d-flex flex-column">
        <section class="d-flex flex-column justify-content-start align-items-start px-4">
          <h1 class="text-white mt-3">
            {{ collection.name }}
          </h1>
          <p class="lead text-light my-3 px-0 mx-0">
            {{ collection.description }}
          </p>
        </section>
        <ProductListWithoutCarousel :products="collectionProducts" />
        <b-button v-if="collection.products.length !== collection.totalProductsCount" variant="primary" class="d-flex justify-content-center col-md-3 col-sm-6 col-xxs-12 mb-3 mx-auto" @click="loadMore">
          {{ $t('collection.showMore') }}
        </b-button>
      </article>
    </div>
  </main>
</template>

<script>
import ProductListWithoutCarousel from '@/components/ProductListWithoutCarousel.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MusicCollectionDetail',
  components: {
    ProductListWithoutCarousel
  },
  props: {
    collection: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl'
    }),
    collectionProducts () {
      return this.collection.products.map(value => {
        return {
          title: value.name,
          imageUrl: value.icon,
          publisher: value.publisher ? value.publisher.name : '',
          targetUrl: '/product/' + value.id,
          genre: value.genres
            .map(g => {
              return g.name
            })
            .join(', ')
        }
      })
    }
  },
  methods: {
    ...mapActions({
      loadCollectionProducts: 'productCatalog/loadCollectionProducts'
    }),
    loadMore () {
      this.loadCollectionProducts(this.collection.id)
    }
  }
}
</script>
